import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const ProductDescription = ({
  description,
}: {
  description: string
}) => {
  const { t } = useLocalization()

  return (
    <Column className="gap-2">
      <h3 className="text-lg">{t('Description', 'Beskrivning')}</h3>
      <p
        className="text-sm leading-relaxed"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Column>
  )
}
